<template>
  <div style="padding: 20px 0px;text-align: center">
    <van-row gutter="10">
      <van-col span="1"></van-col>
      <van-col span="22">
        <van-button @click="onUpdateOrder('RESTART',null)" block type="danger">{{$t('重启')}}</van-button></van-col>
<!--      <van-col span="7"><van-button @click="onUpdateOrder('POWER',true)" block color="#5E75DD">唤醒</van-button></van-col>-->
<!--      <van-col span="7"><van-button @click="onUpdateOrder('POWER',false)" block color="#3B4D7B">休眠</van-button></van-col>-->
      <van-col span="1"></van-col>
    </van-row>
  </div>

</template>

<script>
import {Sticky, Button, Row, Col, Toast} from 'vant';
import {updateOrder} from "@/api/device";
import {getImei} from "@/util/session-storage-utils";
export default {
  components:{
    [Sticky.name]:Sticky,
    [Button.name]:Button,
    [Row.name]:Row,
    [Col.name]:Col,
  },
  name: "fast-order-index",
  methods:{
    onUpdateOrder(name,data){
      Toast.loading({message:this.$t("发送中"),duration:0,position:"top"})
      updateOrder(getImei(),{name,data}).then(() => {
        Toast.success({message:this.$t("指令发送成功"),position:"top"})
      })
    },
  }
}
</script>

<style scoped>

</style>
